import React, {createRef} from "react"

import TaskFinder from "../../../../gd-components/finder/task/task-finder"

type Props = {
    searchString        : string

    selectedProjectId?  : ID
    selectedTaskId?     : ID
    excludedTasksIds    : ID[]

    onClickTask         : func
}

export default class ModalMoveTo_SelectTaskFinder extends React.Component<Props, any> {

    private taskFinderRef: any = createRef()

    componentDidUpdate(prevProps: Props, prevState: any) {
        if (prevProps.searchString !== this.props.searchString)
            this.taskFinderRef.current.onSearchChange(this.props.searchString ? this.props.searchString : '')
    }

    render() {
        return (
            <TaskFinder ref                 = {this.taskFinderRef}
                        className           = "move-to-main"
                        noHeader            = {true}
                        noSubtasks          = {true}
                        parentProjectId     = {this.props.selectedProjectId}
                        selectedTaskId      = {this.props.selectedTaskId}
                        excludedTasksIds    = {this.props.excludedTasksIds}
                        onClickTask         = {this.props.onClickTask}/>
        )
    }
}